import { useEffect } from "react";
import { useStore } from "esr-core/state";
import PropertyInput from "esr-core/input-property";
import { H, ViewCopy, ViewDialog } from "esr-core/view_dialog";

type VersorgungsStatus = "ausserhalb Versorgungsgebiet" | "Fernwärmeanschluss möglich" | "kein Fernwärmeanschluss möglich" | "Fernwärmeanschluss perspektivisch möglich";

export default function ViewBase2() {
  return (<ViewDialog ><ViewBase2Inner /></ViewDialog>)
}

export function ViewBase2Inner() {

   // @ts-ignore:TS2339
  // const api_login = useStore((state) => state.api_login);
  // const api_basic_data = useStore((state)=>state.api_basic_data);
  // const api_financial_plan_dummy = useStore((state)=>state.api_financial_plan_dummy);
  // const api_recalculate = useStore((state) => state.api_recalculate);
  // const measure_labels = useStore((state) => state.measure_labels);
  // const set_measure_labels = useStore((state) => state.set_measure_labels);
  const session_token = useStore((state) => state.session_token);


  const strasse = useStore((state) => state.strasse);
  const hausnummer = useStore((state) => state.hausnummer);
  const postleitzahl = useStore((state) => state.postleitzahl);
  const set_property = useStore((state) => state.set_property);
  const measure_labels = useStore((state) => state.measure_lables);
  const trade_measures = useStore((state) => state.trade_measures);
  
  const set_measure_filter = useStore((state) => state.set_measure_filter);

  useEffect(()=>{
    set_property("strasse", (document!.querySelector('meta[name="address_street"]')?.getAttribute('content')) || "");
    set_property("hausnummer", document!.querySelector('meta[name="address_house_number"]')?.getAttribute('content'));
    set_property("postleitzahl", document!.querySelector('meta[name="address_zip"]')?.getAttribute('content'));
    // set_property("stadt", document!.querySelector('meta[name="address_city"]')?.getAttribute('content'));
    // set_property("land", document!.querySelector('meta[name="address_country"]')?.getAttribute('content'));
  },[]);

  useEffect(()=>{
    function set_meta(key:string, value:string | number){
          if(!value){ return; }
          let meta = document!.querySelector('meta[name="'+key+'"]');
          if (meta){
            meta.setAttribute('content', value);
          }else{
            meta = document.createElement('meta');
            meta.name = key;
            meta.content = value;
            document!.head.appendChild(meta);
          }
    }

    async function test_adress(){
      const url = `https://esrapi.fe-bis.de/api/calc/check_district_heating_status?sessionToken=${session_token}`;
      const result = await fetch(url, {
                        method: "post",
                        headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          "X-Embarcadero-App-Secret" : "CBC!ApiEsrCal2025"
                        },
                        body: JSON.stringify({
                          zip:  postleitzahl!.toString(),
                          num : hausnummer!.toString(),
                          street : strasse!.toString(),
                        })
                      });
      const json = await result.json();
      const status : VersorgungsStatus = json.status;
    
      if(result){
       if (status == "Fernwärmeanschluss möglich" || status == "Fernwärmeanschluss perspektivisch möglich"){
          console.log("Fernwärmeanschluss möglich");
          set_measure_filter("heating_system", "planned_state", (a) => a.code == "heating_system_planned_5");
       } else if(status ==  "kein Fernwärmeanschluss möglich"){
          console.log("kein Fernwärmeanschluss möglich");
          set_measure_filter("heating_system", "planned_state", (a)=> a.code != "heating_system_planned_5");
       }else{
          console.log("ausserhalb Versorgungsgebiet", trade_measures);
          set_measure_filter("heating_system", "planned_state", (a)=> true);
       }
      }
    }

    set_meta("address_street", strasse);
    set_meta("address_house_number", hausnummer);
    set_meta("address_zip", postleitzahl || "");

    if(strasse && hausnummer && postleitzahl && postleitzahl.length > 4){
      test_adress();
    }
  },[strasse, hausnummer, postleitzahl]);
  
  return (<>
            <ViewCopy><H>Die Berechnung mit den Basisdaten zum Haus starten.</H></ViewCopy>
            <PropertyInput placeholder_prefix="z.B." type={"strasse"}/>
            <PropertyInput placeholder_prefix="z.B." type={"hausnummer"}/>
            <PropertyInput placeholder_prefix="z.B." type={"postleitzahl"}/>
            <PropertyInput placeholder_prefix="z.B." type={"vollgeschosse"}/>
            <PropertyInput placeholder_prefix="z.B." type={"wohneinheiten"}/>
            <PropertyInput placeholder_prefix="z.B." type={"baujahr_base"}/>
            <PropertyInput placeholder_prefix="z.B." type={"wohnflaeche"}/>
            <PropertyInput type={"privat"}/>
         </>)
}